module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": _vm.tableId
    }
  }, [_c('table', {
    staticClass: "zefun_table hidetable",
    class: {
      'table-fixed': _vm.fixedStatus
    },
    style: ({
      'top': _vm.fixedTop + 'px'
    })
  }, [_c('thead', _vm._l((_vm.trData), function(trItem) {
    return _c('tr', _vm._l((trItem.thArr), function(thItem, index) {
      return _c('th', {
        class: thItem.class,
        style: ({
          'width': thItem.width + 'px'
        }),
        attrs: {
          "rowspan": thItem.rowspan,
          "colspan": thItem.colspan
        },
        domProps: {
          "innerHTML": _vm._s(thItem.text)
        }
      })
    }))
  }))]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d87d8ad2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fixedTable.vue
// module id = 248
// module chunks = 2